import type { StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

/**
 * Pure id helpers shared across the editor-remix UI and the Confluence
 * remix-history reducer. Kept dependency-free so the reducer can import them
 * without pulling in the heavier message/bridge utilities.
 */

/** Id of the AIFC final message whose action produced the on-page result. */
export const getFinalMessageId = (message: StoreAssistant | undefined): string | undefined =>
	message?.content?.message?.message?.id;

// Matches a MAUI app URL of the form `/remix/ui/{appId}` and captures the id.
// The `u` flag is unavailable at the package build target (TS1501).
// eslint-disable-next-line require-unicode-regexp
const MAUI_APP_PATH_REGEX = /\/remix\/ui\/([\w-]+)/;

/** Extracts the MAUI app id from a `/remix/ui/{appId}` URL. */
export const getMauiIdFromUrl = (url: string | undefined): string | undefined =>
	url ? MAUI_APP_PATH_REGEX.exec(url)?.[1] : undefined;

type MauiAdfNode = {
	attrs?: {
		extensionKey?: unknown;
		parameters?: {
			macroParams?: {
				url?: { value?: unknown };
			};
		};
	};
};

/** Extracts the MAUI app id from a native MAUI extension node. */
export const getMauiIdFromAdfNode = (value: unknown): string | undefined => {
	if (typeof value !== 'object' || value === null) {
		return undefined;
	}

	const attrs = (value as MauiAdfNode).attrs;
	if (attrs?.extensionKey !== 'native-embed:maui') {
		return undefined;
	}

	const url = attrs.parameters?.macroParams?.url?.value;
	return getMauiIdFromUrl(typeof url === 'string' ? url : undefined);
};
